export default function(bounds) {
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()
  const nw = new google.maps.LatLng(ne.lat(), sw.lng())
  const se = new google.maps.LatLng(sw.lat(), ne.lng())

  const latLngList = [ne, nw, sw, se]
  const area = google.maps.geometry.spherical.computeArea(latLngList)
  // console.log('Area: ', area)
  return area
}



// WEBPACK FOOTER //
// ./src/utils/zoomMapBoundaries.js